var $ = jQuery;
var mobile = 700;

$(document).ready(function() {
    if(_site.module == "home") {
        attachMapLoad();
    }
    attachMenuLines();
    attachMenuToggleBack();
    attachAccordion();
    createLayoutStructure();
    attachCountrySelect();
    attachFooterToggle();
    attachExternalLinks();
    attachSameHeight();
    $(window).resize(function() {
        attachMenuToggleBack();
        createLayoutStructure();
    });
});

var maxh = 0;
function attachSameHeight() {
    $('.same_height').each(function(i, v) {
        var th = $(this).height();
        if(th > maxh) {
            maxh = th;
        }
    });

    $('.same_height').css('display', 'block');
    $('.same_height').height(maxh);
}
function attachExternalLinks() {
	$('a').on('click', function(e) {
        if (link_is_external(this)) {
            var href = $(this).attr('href');
            if(!confirm("Te lahkute praegu lehelt. Me ei kontrolli väliste veebisaitide sisu ning see hüperlink ei kujuta endast saidi sisu heakskiitu.")) {
                e.stopPropagation();
                return false;
            }
        }
	});
}
function link_is_external(link_element) {
	var href = $(link_element).attr('href');
	if(href != undefined && href != 'javascript:;') {
		if(href.substr(0,4) == "http" || href.substr(0,4) == "www.") {
			return (link_element.host !== window.location.host);
		}
	}
	return false;
}

function attachFooterToggle() {
    $('.openclose_toggle').on('click', function() {
        $('#site_footer').toggleClass('closed');
        createLayoutStructure();
        if(_site.module == "home") {
            attachMapLoad();
            map.invalidateSize();
            checkLeftScroll();
        }
    });
}

function attachCountrySelect() {
    $('.country_select').on('change', function() {
        var url = $(this).val();
        location.href = url;
    })
}

function attachMapLoad() {
    var ww = $(window).height();
    var fh = $('#site_footer').height();

    var map = $('#map');
    var mh = ww - fh - 60;
    map.height(mh);
}

function createLayoutStructure() {
    var wdw = $(window);
    var sf = $('#site_footer');
    if(wdw.width() > 700) {
        var cc = $('#core_container');
        var sf_top = parseInt(sf.offset().top);
        var sf_height = parseInt(sf.outerHeight());
        var sf_bot = parseInt(sf_top) + parseInt(sf_height);

        if(sf_bot < wdw.height()) {
            sf.addClass('fixed');
            
            var cn_height = wdw.height() - sf_height;

            if(cn_height > 800) {
                cc.css('min-height', cn_height);
                $('.col2').css('min-height', cn_height);
                $('.col2 .core_image').css('min-height', cn_height);
            }
        } else {
            var mh = $('.col1').height();
            if(mh > 800) {
                $('.col2').css('min-height', mh);
                $('.col2 .core_image').css('min-height', mh);
            }
        }
            

        var cc_h = parseInt(cc.css('height'));
        if( (cc_h + sf_height) > wdw.height()) {
            cc.css('min-height', '700px');
            sf.removeClass('fixed');
        }
    } else {
        sf.removeClass('fixed');
    }
}

function attachMenuLines() {
    $('nav li').each(function(i, v) {
        $(v).append("<div class='menu_line'></div>");
    });
}

function attachMenuToggleBack() {
    $('.menu_toggle').attr('href','javascript:;');
    $(".menu_toggle").prop("onclick", null).off("click");
    attachDesktopMenu();
    attachMobileMenu();
}

function attachDesktopMenu() {
    if($(window).width() > mobile) {
        $('.menu_toggle').attr('href', 'index.html');
    }
}
function attachMobileMenu() {
    if($(window).width() <= mobile) {
        var wh = $(window).height();
        if(_site.module == "home") {
            var nnh = wh - 109;
        } else {
            var nnh = wh - 125;
        }
        $('#site_header nav').css('min-height', nnh);
        $('.menu_toggle').on('click', function() {
            $('#site_header').toggleClass('open');
        })
    }
}

function attachAccordion() {
    $('.acc_item').on('click', function() {
        $('.acc_item').removeClass('open').addClass('closed');
        $(this).addClass('open').removeClass('closed');
    });
}